import { useEffect, useState } from "react";

import { mobileMaxWidth } from "../../constants/layout";
import StoryMobile from "./StoryMobile";
import StoryTablet from "./StoryTablet";

export default function Story() {
  const [isTablet, setIsTablet] = useState(
    () => window.innerWidth > mobileMaxWidth,
  );

  useEffect(() => {
    const onResize = () => setIsTablet(window.innerWidth > mobileMaxWidth);

    window.addEventListener("resize", onResize);

    return () => window.removeEventListener("resize", onResize);
  }, []);

  return isTablet ? <StoryTablet /> : <StoryMobile />;
}
